import React from 'react';
import './HeightWarningModal.css';

const HeightWarningModal = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>⚠️ Advertencia</h2>
        <p>La altura de la ventana excede el límite recomendado de 1.600 mm para una Corredera Chica.</p>
        <p>¿Desea continuar de todas formas?</p>
        <div className="modal-buttons">
          <button 
            className="modal-button cancel" 
            onClick={onCancel}
          >
            Cancelar
          </button>
          <button 
            className="modal-button confirm" 
            onClick={onConfirm}
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeightWarningModal; 